<template>
	<div>
		<div class="orders-products">
			<orders-products
				:rows="rowsProduct"
				:order="order"
			/>
		</div>
	</div>
</template>
<script>
import ordersProducts from '@/components/profile/orders-products';

function created() {
	({ id: this.id } = this.$route.params);
	this.loadData();
}

async function loadData() {
	const headers = {
		Authorization: `Bearer ${this.$store.getters.token}`,
	};
	const url = `orders/${this.id}`;
	({ data: this.order } = await this.$httpJapi(url, { headers }));
	this.rowsProduct = [...this.order.details];
}

function data() {
	return {
		headersMobile: [
			{ name: 'FECHA' },
			{ name: 'ESTADO' },
			{ name: 'METODO DE PAGO' },
		],
		headerProducts: [
			{ name: 'Producto' },
			{ name: 'Precio Unitario' },
			{ name: 'Cantidad' },
			{ name: 'Precio Sub.' },
		],
		id: 0,
		order: {},
		rowsProduct: [],
	};
}

export default {
	name: 'details',
	components: {
		ordersProducts,
	},
	created,
	data,
	methods: {
		loadData,
	},
};
</script>

<style lang="scss" scoped>
@media screen and (max-width: 800px) {
	.orders-products {
		display: block;
	}
}
</style>



// WEBPACK FOOTER //
// details.vue?1fba3e72